import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "number"]
  static values = {
    clicks: Number,
    id: String
  }

  connect() {
    this.clicksValue = 0
    this.idValue = this.element.dataset.revealIdValue
  }

  toggleNumber(event) {
    event.preventDefault()
    this.buttonTarget.classList.add("hidden")
    this.numberTarget.classList.remove("hidden")
    this.incrementClicks()
  }

  incrementClicks() {
    this.clicksValue++
    this.sendClicksToGA4()
  }

  sendClicksToGA4() {
    if (typeof gtag === 'function') {
      gtag('event', 'phone_number_click', {
        'poi_id': this.idValue,
        'clicks': this.clicksValue
      })
    }
  }
}